import { getConfiguration } from '../../shared/configuration/config-settings';

const config = getConfiguration();

let _cookieDomain: string;

switch (true) {
  case window.location.hostname.includes('localhost'):
    _cookieDomain = window.location.hostname.includes('patient') ? 'patient.localhost' : '.localhost';
    break;
  case window.location.hostname.includes('myfinpay'):
    _cookieDomain = '.myfinpay.net';
    break;
  default:
    _cookieDomain = config.app_environment === 'prod' ? '.finpay.net' : `.${config.app_environment}.finpay.net`;
}

export const cookieDomain = _cookieDomain;
